import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  STAFF_TYPOLOGY_LIST: 'organization-staff-typology'
}

const routes = [
  {
    path: 'staff-typology/',
    name: ROUTES.STAFF_TYPOLOGY_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['organization_stafftypology_list'],
      requiresAuth: true
    },
    component: () => import('./StaffTypologyList.vue')
  }

]

export { routes, ROUTES }
